import client from './client'

export default {
  destroy: (userId, id) => {
    return client
      .delete(`/api/admin/users/${userId}/credit_cards/${id}`)
      .send()
  }
}
